import { CollaboratorEntity } from './collaboratorModel';

export function getCollaboratorLabel(item: CollaboratorEntity): string {
    if (item.first_name || item.last_name) {
        return [item.first_name, item.last_name].join(' ');
    }
    return item.email;
}
